import { render, staticRenderFns } from "./Kontak.vue?vue&type=template&id=e355c0ba&scoped=true"
import script from "./Kontak.vue?vue&type=script&lang=js"
export * from "./Kontak.vue?vue&type=script&lang=js"
import style0 from "./Kontak.vue?vue&type=style&index=0&id=e355c0ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e355c0ba",
  null
  
)

export default component.exports